import { Badge, Box, Breadcrumb, BreadcrumbItem, BreadcrumbLink, Button, Flex, Stack, Tab, TabList, TabPanel, TabPanels, Tabs, Text } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { PiPlusBold } from 'react-icons/pi';
import Confirmation from './Confirmation';
import Stock from './Stock';
import Suivi from './Suivi';
import { useStateContext } from '../../../../context/ContextProvider';
import Facture from './Facture';

function MyOrders() {
    const navigate = useNavigate()
    const { t } = useTranslation();
    const { user, dataSubscriptionUser } = useStateContext()
    return (
        <Box position="relative" mb={5}>

            {/* <Flex zIndex={999} position={"fixed"} bottom={10} right={5}>
                <Button

                    onClick={() => {
                        navigate("/NewOrder")
                    }}
                    colorScheme='purple'
                >
                    <PiPlusBold size={18} />

                </Button>
            </Flex> */}

            <Flex>
                <Box w="100%" display={"flex"} justifyContent="space-between" flexDirection={{ base: 'column', md: "row" }} mt={2} mb={{ base: 0, md: 5 }}>
                    <Breadcrumb fontFamily='Plus Jakarta Display' fontStyle={"italic"} fontSize={{ base: "20px", sm: "25px", lg: "27px" }} color="gray">
                        <BreadcrumbItem>
                            <BreadcrumbLink onClick={() => navigate('/')}>{t("Accueil")}</BreadcrumbLink>
                        </BreadcrumbItem>

                        <BreadcrumbItem isCurrentPage>
                            <BreadcrumbLink>{t("Mes commandes")}</BreadcrumbLink>
                        </BreadcrumbItem>
                    </Breadcrumb>

                    <Flex align="center" gap={5} direction="row" justify="end">
                        {
                            dataSubscriptionUser?.message === 'Client has no active subscription' ?
                                <Badge colorScheme='red'
                                    rounded="xl"
                                    title={t("Pas d'abonnement actif")}
                                    px={2}>
                                    {t("Pas d'abonnement actif")} !
                                </Badge>
                                :
                                dataSubscriptionUser?.subscription?.demande || !dataSubscriptionUser?.subscription?.is_active
                                    ?
                                    <>
                                        {dataSubscriptionUser?.subscription?.demande
                                            &&
                                            <Badge colorScheme='red'
                                                rounded="xl"
                                                title={t("Votre abonnement n'est pas encore accepté")}
                                                px={2}>
                                                {t("Abonnement en attente")}
                                            </Badge>}

                                        {!dataSubscriptionUser?.subscription?.demande && !dataSubscriptionUser?.subscription?.is_active
                                            &&
                                            <Badge colorScheme='red'
                                                rounded="xl"
                                                title={t("Votre abonnement est désactivé")}
                                                px={2}>
                                                {t("Abonnement désactivé")}
                                            </Badge>}
                                    </>
                                    :
                                    <Badge colorScheme={parseInt(dataSubscriptionUser?.subscription?.orders_count) === parseInt(dataSubscriptionUser?.orders_limit) ? 'red' : 'green'}
                                        rounded="xl"
                                        title={parseInt(dataSubscriptionUser?.subscription?.orders_count) === parseInt(dataSubscriptionUser?.orders_limit) ? t('Vous avez atteint la limite de commandes pour votre abonnement') : t("Nombre de commandes restantes")}
                                        px={2}>
                                        {dataSubscriptionUser?.subscription?.orders_count} / {dataSubscriptionUser?.orders_limit} {t('commandes')}
                                    </Badge>
                        }
                    </Flex>
                </Box>

            </Flex>

            <Stack>
                <Tabs isLazy>
                    <TabList>
                        <Tab>
                            <Text fontSize={{ base: 12, lg: 15 }}>{t("Confirmation")}</Text>
                        </Tab>
                        <Tab>
                            <Text fontSize={{ base: 12, lg: 15 }}>{t("Stock")}</Text>
                        </Tab>
                        <Tab>
                            <Text fontSize={{ base: 12, lg: 15 }}>{t("Suivi")}</Text>
                        </Tab>
                        <Tab>
                            <Text fontSize={{ base: 12, lg: 15 }}>{t("Facture")}</Text>
                        </Tab>
                    </TabList>
                    <TabPanels>
                        <TabPanel>
                            {user && <Confirmation user={user} dataSubscriptionUser={dataSubscriptionUser} />}
                        </TabPanel>
                        <TabPanel>
                            <Stock />
                        </TabPanel>
                        <TabPanel>
                            <Suivi />
                        </TabPanel>
                        <TabPanel>
                            <Facture />
                        </TabPanel>
                    </TabPanels>
                </Tabs>
            </Stack>
        </Box>
    )
}

export default MyOrders